import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges } from '@angular/core';
import { TabComponent } from 'src/app/shared/assertion/tab/tab.component';
import { AlertsService } from '../alerts-custom.service';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { AlertsvarService } from '../alertsvar.service';

@Component({
  selector: 'events-tabs',
  templateUrl: './events-tabs.component.html',
  styleUrls: ['./events-tabs.component.scss']
})
export class EventsTabsComponent implements OnInit, AfterContentInit, OnChanges {
  constructor(
    public alertService: AlertsService,
    public alertvarservice: AlertsvarService

  ) { }

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() selectedIndexChange: EventEmitter<number> = new EventEmitter<number>()
  @Input() selectedIndex: number;
  @Input() clickchange: boolean = true;
  @Input() isProgress: boolean = false;

  currentIndex: number = 0;
  
  ngOnInit(): void {
    this.currentIndex = this.selectedIndex;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.selectedIndexChanged(changes)
  }

  ngAfterContentInit(): void {
    let activeTabs = this.tabs.filter((tab) => tab.active);
    if (activeTabs.length === 0 && !this.currentIndex) {
      this.tabs.first.active = true;
      this.currentIndex = 0
    } else {
      this.tabs.toArray()[this.currentIndex].active = true;
    }
  }

  closeTab() {
    this.tabs.toArray().forEach(tab => tab.active = false);
  }

  checkPresentTab(previousindex: number, index: number) {
    return previousindex !== index
  }

  selectTab(tab: TabComponent, index: number) {
    if (this.checkPresentTab(this.currentIndex, index) && this.clickchange) {
      this.closeTab()
      this.activeTab(index)
    }
  }

  activeTab(index: number) {
    this.tabs.toArray()[index].active = true;
    this.currentIndex = index;
    this.selectedIndexChange.emit(index)
  }

  selectedIndexChanged(changes: any) {
    if (changes.selectedIndex) {
      if (!changes.selectedIndex.firstChange && this.checkPreviousIndex()) {
        this.currentIndex = this.selectedIndex;
        this.closeTab()
        this.activeTab(changes.selectedIndex.currentValue);
      }
    }
  }

  checkPreviousIndex() {
    return this.selectedIndex != this.currentIndex;
  }

  close_factsheet(){
    if(!this.isProgress) {
      this.alertvarservice.factSheetOpened = false;
      this.alertvarservice.resetFactsheetPanels();
    }

  }
  closeEventsPanel() {
//console.log('events-tab  closeEventsPanel',this.alertvarservice.eventsPanel);
    
    // this.alertvarservice.currentIndex = 1
    // this.alertvarservice.isVisibleEvents = false;
    this.alertvarservice.alertEventsListView = true;
    // this.alertvarservice.eventlist.length = 0;
    this.alertvarservice.eventsPanel = 0
    this.alertvarservice.changeCanvas()
  }

}
